module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/fde25ea8f24150a068c9ceaba6325eb8.png";